import { render, staticRenderFns } from "./package_path.vue?vue&type=template&id=c4befdb4&"
import script from "./package_path.vue?vue&type=script&lang=js&"
export * from "./package_path.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports